// extracted by mini-css-extract-plugin
export default {"greenBlockContainer":"styles_greenBlockContainer__qxRok","whiteBorder":"styles_whiteBorder__VSGaC","greenBlock":"styles_greenBlock__sza4n"};